/**
 * Width of height of each size of hp-icon
 */
// TODO: consume these values in src/styles/_icon-sizes.scss
const iconSizes = {
  xs: 18,
  sm: 24,
  md: 36,
  lg: 66,
  xl: 96,
};

export default iconSizes;
